import type { RouterConfig } from '@nuxt/schema'

export default <RouterConfig>{
    scrollBehavior(to, from, savedPosition) {
        // Si hash (ancre), on scroll vers l'élément
        if (to.hash) {
            return {
                el: to.hash,
                behavior: 'smooth',
                top: 120 // Compensation pour le header fixe
            }
        }

        // Si retour arrière, on garde la position
        if (savedPosition) {
            return savedPosition
        }

        // Sinon, retour en haut de page
        return { top: 0, left: 0 }
    }
}
